import React, { useState, useEffect } from 'react';
import api from '../services/api';
import useToast from '../hooks/useToast';
import ToastContainer from '../components/ToastContainer';

const TumCalisanlarPage = () => {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [departmentFilter, setDepartmentFilter] = useState('');
  const [roleFilter, setRoleFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [departments, setDepartments] = useState([]);
  const { toasts, addToast, removeToast } = useToast();
  const apiUrl = process.env.REACT_APP_API_URL;
  const fetchEmployees = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams({
        page: currentPage,
        limit: 12,
        search: searchTerm,
        department: departmentFilter,
        role: roleFilter,
        status: statusFilter
      });

      const response = await api.get(`/api/users?${params}`);
      
      if (response.success) {
        setEmployees(response.users);
        setTotalPages(response.pagination.pages);
      }
    } catch (error) {
      console.error('Çalışanlar yüklenirken hata:', error);
      addToast('Çalışanlar yüklenirken bir hata oluştu', 'error', 5000);
    } finally {
      setLoading(false);
    }
  };

  const fetchDepartments = async () => {
    try {
      const response = await api.get('/api/users/departments');
      if (response.success) {
        setDepartments(response.departments);
      }
    } catch (error) {
      console.error('Departmanlar yüklenirken hata:', error);
    }
  };

  useEffect(() => {
    fetchEmployees();
    fetchDepartments();
  }, [currentPage, searchTerm, departmentFilter, roleFilter]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleDepartmentFilter = (e) => {
    setDepartmentFilter(e.target.value);
    setCurrentPage(1);
  };

  const handleRoleFilter = (e) => {
    setRoleFilter(e.target.value);
    setCurrentPage(1);
  };

  const handleStatusFilter = (e) => {
    setStatusFilter(e.target.value);
    setCurrentPage(1);
  };

  const clearFilters = () => {
    setSearchTerm('');
    setDepartmentFilter('');
    setRoleFilter('');
    setStatusFilter('');
    setCurrentPage(1);
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString('tr-TR');
  };

  const getRoleBadgeClass = (role) => {
    switch (role) {
      case 'admin':
        return 'modern-employee-badge-admin';
      case 'manager':
        return 'modern-employee-badge-manager';
      default:
        return 'modern-employee-badge-employee';
    }
  };

  const getRoleText = (role) => {
    switch (role) {
      case 'admin':
        return 'Yönetici';
      case 'manager':
        return 'Müdür';
      default:
        return 'Çalışan';
    }
  };

  return (
    <div className="modern-hr-page">
      <div className="container-fluid">
        <div className="modern-hr-header">
          <div className="modern-hr-header-content">
            <div className="modern-hr-header-text">
              <h1>Tüm Çalışanlar</h1>
              <p>Şirket çalışanlarının listesi ve detayları</p>
            </div>
            <div className="modern-hr-header-actions">
              <div className="modern-hr-stats">
                <div className="modern-hr-stat-item">
                  <i className="bx bx-group"></i>
                  <span>{employees.length} Çalışan</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Filtreler */}
        <div className="modern-hr-widget">
          <div className="modern-hr-widget-header">
            <div className="modern-hr-widget-title">
              <i className="bx bx-filter"></i>
              <h4>Filtreler ve Arama</h4>
            </div>
            <div className="modern-hr-widget-actions">
              <button
                onClick={clearFilters}
                className="modern-hr-btn modern-hr-btn-secondary modern-hr-btn-sm"
              >
                <i className="bx bx-x"></i>
                Temizle
              </button>
            </div>
          </div>

          <div className="modern-hr-filters">
            <div className="row">
              <div className="col-md-4">
                <div className="modern-hr-form-group">
                  <label className="modern-hr-form-label">Arama</label>
                  <div className="modern-hr-search-input">
                    <i className="bx bx-search"></i>
                    <input
                      type="text"
                      value={searchTerm}
                      onChange={handleSearch}
                      placeholder="Ad, soyad, email veya departman ara..."
                      className="modern-hr-form-input"
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-3">
                <div className="modern-hr-form-group">
                  <label className="modern-hr-form-label">Departman</label>
                  <select
                    value={departmentFilter}
                    onChange={handleDepartmentFilter}
                    className="modern-hr-form-select"
                  >
                    <option value="">Tüm Departmanlar</option>
                    {departments.map((dept, index) => (
                      <option key={index} value={dept}>
                        {dept}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="col-md-3">
                <div className="modern-hr-form-group">
                  <label className="modern-hr-form-label">Rol</label>
                  <select
                    value={roleFilter}
                    onChange={handleRoleFilter}
                    className="modern-hr-form-select"
                  >
                    <option value="">Tüm Roller</option>
                    <option value="employee">Çalışan</option>
                    <option value="manager">Müdür</option>
                    <option value="admin">Yönetici</option>
                  </select>
                </div>
              </div>

              <div className="col-md-2">
                <div className="modern-hr-form-group">
                  <label className="modern-hr-form-label">Durum</label>
                  <select
                    value={statusFilter}
                    onChange={handleStatusFilter}
                    className="modern-hr-form-select"
                  >
                    <option value="">Tüm Durumlar</option>
                    <option value="active">Aktif</option>
                    <option value="inactive">Pasif</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Çalışan Listesi */}
        <div className="modern-hr-widget">
          <div className="modern-hr-widget-header">
            <div className="modern-hr-widget-title">
              <i className="bx bx-group"></i>
              <h4>Çalışan Listesi</h4>
            </div>
            <div className="modern-hr-widget-actions">
              <div className="modern-hr-view-controls">
                <button className="modern-hr-btn modern-hr-btn-secondary modern-hr-btn-sm">
                  <i className="bx bx-grid-alt"></i>
                  Grid
                </button>
                <button className="modern-hr-btn modern-hr-btn-secondary modern-hr-btn-sm">
                  <i className="bx bx-list-ul"></i>
                  Liste
                </button>
              </div>
              <span className="modern-hr-count">
                {employees.length} çalışan
              </span>
            </div>
          </div>

          {loading ? (
            <div className="modern-hr-loading">
              <i className="bx bx-loader-alt bx-spin"></i>
              <p>Çalışanlar yükleniyor...</p>
            </div>
          ) : employees.length === 0 ? (
            <div className="modern-hr-empty">
              <i className="bx bx-user-x"></i>
              <h5>Çalışan bulunamadı</h5>
              <p>Arama kriterlerinize uygun çalışan bulunamadı</p>
            </div>
          ) : (
            <>
              <div className="modern-employee-list">
                {employees.map((employee) => (
                  <div key={employee._id} className="modern-employee-list-item">
                    <div className="modern-employee-list-avatar">
                      {employee.avatar?.filePath ? (
                        <img 
                          src={`${apiUrl}/${employee.avatar.filePath}`} 
                          alt={`${employee.firstName} ${employee.lastName}`}
                        />
                      ) : (
                        <div className="modern-employee-avatar-placeholder">
                          {employee.firstName.charAt(0)}{employee.lastName.charAt(0)}
                        </div>
                      )}
                    </div>
                    
                    <div className="modern-employee-list-content">
                      <div className="modern-employee-list-main">
                        <h5 className="modern-employee-name">
                          {employee.firstName} {employee.lastName}
                        </h5>
                        <p className="modern-employee-email">{employee.email}</p>
                        <p className="modern-employee-position">{employee.position}</p>
                        <p className="modern-employee-department">{employee.department}</p>
                      </div>
                      
                      <div className="modern-employee-list-info">
                        <div className="modern-employee-info-item">
                          <i className="bx bx-calendar"></i>
                          <span>{formatDate(employee.startDate)}</span>
                        </div>
                        {employee.phone && (
                          <div className="modern-employee-info-item">
                            <i className="bx bx-phone"></i>
                            <span>{employee.phone}</span>
                          </div>
                        )}
                      </div>
                    </div>
                    
                    <div className="modern-employee-list-badges">
                      <span className={`modern-employee-badge ${getRoleBadgeClass(employee.role)}`}>
                        {getRoleText(employee.role)}
                      </span>
                      {employee.isActive ? (
                        <span className="modern-employee-badge modern-employee-badge-active">
                          Aktif
                        </span>
                      ) : (
                        <span className="modern-employee-badge modern-employee-badge-inactive">
                          Pasif
                        </span>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              {/* Sayfalama */}
              {totalPages > 1 && (
                <div className="modern-hr-pagination">
                  <button
                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                    disabled={currentPage === 1}
                    className="modern-hr-btn modern-hr-btn-secondary"
                  >
                    <i className="bx bx-chevron-left"></i>
                    Önceki
                  </button>

                  <div className="modern-hr-pagination-info">
                    Sayfa {currentPage} / {totalPages}
                  </div>

                  <button
                    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                    disabled={currentPage === totalPages}
                    className="modern-hr-btn modern-hr-btn-secondary"
                  >
                    Sonraki
                    <i className="bx bx-chevron-right"></i>
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </div>

      {/* Toast Container */}
      <ToastContainer toasts={toasts} removeToast={removeToast} />
    </div>
  );
};

export default TumCalisanlarPage;
